import { normalizeSeriesId } from "../../shared/vehicleIdentity";

/**
 * Where the old `/towingPayload/:model/:year/:code` route redirects to.
 *
 * The calculator lives on its own Dynamic Page; this maps the old path params
 * onto its query-param URL. Kept because favorites, bookmarks, the vehicle page's
 * `externalLinks.tp` and Mission Control's template preview still point here.
 */
export const towingPayloadPath = ({ model, year, code } = {}) => {
  const qs = new URLSearchParams();
  if (model) {
    qs.set("vehicle", normalizeSeriesId(model));
  }
  if (year) {
    qs.set("year", year);
  }
  if (code) {
    qs.set("trim", code);
  }
  const query = qs.toString();
  return `/pages/towing-payload/main${query ? `?${query}` : ""}`;
};
